import { Empty } from 'antd';
import { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getCompanies, getJobsByType } from '../../api/public';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useParams } from 'react-router-dom';
import { CardComponent } from './components/VacancyCard/VacancyCard';
import { CompanyCard } from './components/TrustedUs/TrustedUs';

export const AllCompanies = () => {
  const [trusedUs, setTrusedUs] = useState([]);
  const [page, setPage] = useState(1);
  const { type } = useParams();
  console.log('🚀 ~ AllCompanies ~ type:', type);
  const [meta, setMeta] = useState({ hasNextPage: true });
  const { t } = useTranslation();

  const fetchData = async pageNumber => {
    try {
      const paramType = type === 'intern' ? 'INTERNSHIP' : type === 'jobs' ? 'VACANCY' : 'COMP';
      const res =
        paramType === 'COMP'
          ? await getCompanies(page)
          : await getJobsByType(pageNumber, paramType);
      const data = res?.data?.data?.items;
      const meta = res?.data?.data?.meta;
      setMeta(meta);

      if (data?.length) {
        setTrusedUs(prevItems => [...prevItems, ...data]);
      } else {
        console.log('No yet data');
      }
    } catch (error) {
    } finally {
      setPage(p => p + 1);
    }
  };

  const fetchMoreData = page => {
    return fetchData(page);
  };

  useEffect(() => {
    fetchMoreData(1);
  }, []);

  const dynamicCard = item => {
    return type === 'comp' ? (
      <CompanyCard item={item} />
    ) : type === 'jobs' ? (
      <CardComponent item={item} />
    ) : (
      <CardComponent item={item} />
    );
  };

  return (
    <div style={{ minHeight: '100vh' }}>
      <div
        className="container pt-4"
        style={{
          height: '100%',
          paddingTop: '12px',
          maxWidth: '1130px',
          margin: '0 auto',
        }}
      >
        <div className="row mb-2">
          <div className="col-12 d-flex justify-content-between align-items-center">
            <h3 style={{ marginLeft: '1rem' }}>
              {t(
                type === 'comp' ? 'allCompanies' : type === 'intern' ? 'allInternships' : 'allJobs',
              )}
            </h3>
          </div>
        </div>
        <div className="row">
          {trusedUs?.length ? (
            <InfiniteScroll
              style={{
                padding: '0',
                overflow: 'hidden',
              }}
              dataLength={trusedUs.length} //This is important field to render the next data
              next={() => fetchMoreData(page)}
              hasMore={meta?.hasNextPage}
              loader={<h4>Loading...</h4>}
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>{t('itAll')}</b>
                </p>
              }
            >
              {trusedUs?.length ? (
                <Fragment>
                  <div className="row mx-1">{trusedUs.map(item => dynamicCard(item))}</div>
                </Fragment>
              ) : (
                <Empty />
              )}
            </InfiniteScroll>
          ) : (
            <Empty />
          )}
        </div>
      </div>
    </div>
  );
};
